import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGithub, FaLinkedin } from 'react-icons/fa';
import './Contact.css';
import { useForm, ValidationError} from '@formspree/react';

const Contact = () => {
  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: "Email",
      value: "farish.sirraj@gmail.com",
    //   link: "mailto:farish.sirraj@gmail.com"
      link: null

    },
    {
      icon: <FaPhone />,
      title: "Phone",
      value: "+1 (857) 763-0002",
      link: "tel:+18577630002"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Location",
      value: "Boston, Massachusetts",
      link: null
    }
  ];

  const socialLinks = [
    {
      icon: <FaGithub />,
      name: "GitHub",
      url: "https://github.com/farissirraj"
    },
    {
      icon: <FaLinkedin />,
      name: "LinkedIn",
      url: "https://linkedin.com/in/farissirraj"
    },
  ];

  function ContactForm() {
    const [state, handleSubmit] = useForm("mjkodabl");
    if (state.succeeded) {
        return <p>Message Sent! I will be in touch with you soon!</p>;
    }
    return (
      <form onSubmit={handleSubmit}>
        <div className="form-group">
            <input
            id="name"
            type="text" 
            name="name"
            placeholder='Your Name'
            required
            />
        
            <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
            />
        </div>
        
        <div className="form-group">
            <input
            id="email"
            type="email" 
            name="email"
            placeholder='Your email'
            required
            />
        
            <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
            />
        </div>

        <div className="form-group">
            <textarea
            id="message"
            name="message"
            type="text"
            placeholder='Your Message'
            rows="5"
            required
            />
            <ValidationError 
            prefix="Message" 
            field="message"
            errors={state.errors}
            />
        </div>

        <button 
          type="submit" 
          className="btn btn-primary"
        >
            Send Message
        </button>
      </form>
    );
  }

  return (
    <section id="contact" className="contact">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Get In Touch</h2>
          <p>Let's work together on your next project</p>
        </motion.div>

        <div className="contact-content">
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3>Contact Information</h3>
            <p>
              I'm always interested in hearing about new opportunities and exciting projects. 
              Whether you have a question or just want to say hi, feel free to reach out!
            </p>
            
            <div className="contact-details">
              {contactInfo.map((info, index) => (
                <motion.div
                  key={info.title}
                  className="contact-item"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="contact-icon">
                    {info.icon}
                  </div>
                  <div className="contact-text">
                    <h4>{info.title}</h4>
                    {info.link ? (
                      <a href={info.link}>{info.value}</a>
                    ) : (
                      <span>{info.value}</span>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="social-links">
              <h4>Follow Me</h4>
              <div className="social-icons">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, delay: 0.6 + index * 0.1 }}
                    viewport={{ once: true }}
                    whileHover={{ scale: 1.2, y: -3 }}
                  >
                    {social.icon}
                    <span className="social-tooltip">{social.name}</span>
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            className="contact-form"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3>Send Me a Message</h3>
            <ContactForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 